import _ from 'lodash';

export class ChartData {
  constructor(state) {
    this._init(state);
  }

  _init(state) {
    const {title, name, type, data, category, columns} = state;

    const columnFilter = column => !column.hidden;

    const series = _(columns)
        .filter(columnFilter)
        .map(val => ({field: val.field, name: val.title}))
        .value();

    const format = (columns[0] || {}).format || '{0}';

    this.category = category;
    this.dataSource = data;
    this.format = format;
    this.name = name;
    this.series = series;
    this.title = title;
    this.type = type;
  }
}
